module.exports = __webpack_public_path__ + "static/media/480.e049da4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-fly/dark/480.png
// module id = 2072
// module chunks = 2